/* eslint-disable no-control-regex */
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { string } from "yup";

// TODO - Move validations here to not repeat them in every component
export const useValidation = () => {
  const { t } = useTranslation(["validation"]);

  const firstNameValidator = useCallback(
    () =>
      string()
        .min(1, t("validation:string.min.1"))
        .max(255, t("validation:string.max.number", { value: 255 }))
        .matches(/^[^<>&"\v$%!#?§;*~/\\|^=[\]{}()\x00-\x1F\x7F]+$/, t("validation:noSpecialChars"))
        .required(t("validation:required")),
    [t]
  );

  const lastNameValidator = useCallback(
    () =>
      string()
        .min(1, t("validation:string.min.1"))
        .max(255, t("validation:string.max.number", { value: 255 }))
        .matches(/^[^<>&"\v$%!#?§;*~/\\|^=[\]{}()\x00-\x1F\x7F]+$/, t("validation:noSpecialChars"))
        .required(t("validation:required")),
    [t]
  );

  const userNameValidator = useCallback(
    () =>
      string()
        .min(3, t("validation:string.min.number", { value: 3 }))
        .max(255, t("validation:string.max.number", { value: 255 }))
        .matches(/^[^<>&"'\s\v\u00A0$%!#?§,;:*~/\\|^=[\]{}()`\x00-\x1F\x7F]+$/, {
          message: t("validation:username"),
          excludeEmptyString: true,
        }),
    [t]
  );

  const organisationCodeValidator = useCallback(
    (options?: { required?: boolean }) => {
      let schema = string()
        .trim()
        .max(255, t("validation:string.max.number", { value: 255 }));

      if (options?.required !== false) {
        schema = schema.min(1, t("validation:string.min.1")).required(t("validation:required"));
      } else {
        schema = schema.optional();
      }

      return schema;
    },
    [t]
  );

  return {
    firstNameValidator,
    lastNameValidator,
    userNameValidator,
    organisationCodeValidator,
  };
};
